import { useEffect, useRef } from "react";
import { Application, Assets, Sprite, SCALE_MODES } from "pixi.js";

import gearsPng from "../../assets/a_planetary_shift_logo_gears.png";
import casingPng from "../../assets/a_planetary_shift_logo.png";

export default function Logo({
    size = 200,
    rotationSpeed = 0.03,
    tint = 0xcdcdcd,
    className = "",
}) {
    const pixiRef = useRef(null);

    useEffect(() => {
        let app;
        let gearSprite;

        async function initPixi() {
            app = new Application();

            // const DISPLAY_SIZE = 200;
            const DISPLAY_SIZE = size;
            const LOGO_SCALE = DISPLAY_SIZE / 1000;

            await app.init({
                width: DISPLAY_SIZE,
                height: DISPLAY_SIZE,
                backgroundAlpha: 0,
                antialias: true,
                resolution: 2,
                autoDensity: true,
            });

            pixiRef.current.appendChild(app.canvas);

            const [gearsTexture, casingTexture] = await Promise.all([
                Assets.load(gearsPng),
                Assets.load(casingPng),
            ]);

            gearSprite = new Sprite(gearsTexture);
            gearSprite.scale.set(LOGO_SCALE);
            gearSprite.anchor.set(0.5);
            gearSprite.x = DISPLAY_SIZE / 2;
            gearSprite.y = DISPLAY_SIZE / 2;
            gearSprite.tint = tint;
            gearSprite.texture.source.scaleMode = "linear";

            const casingSprite = new Sprite(casingTexture);
            casingSprite.scale.set(LOGO_SCALE);
            casingSprite.anchor.set(0.5);
            casingSprite.x = DISPLAY_SIZE / 2;
            casingSprite.y = DISPLAY_SIZE / 2;
            casingSprite.tint = tint;
            casingSprite.texture.source.scaleMode = "linear";

            app.stage.addChild(gearSprite);
            app.stage.addChild(casingSprite);

            app.ticker.add(() => {
                gearSprite.rotation += rotationSpeed;
            });
        }

        initPixi();

        return () => {
            if (app) {
                app.destroy(true);
            }
        };
    }, []);

    // return <div className="pixi-logo" ref={pixiRef}></div>
    return (
        <div
            className={`pixi-logo ${className}`}
            ref={pixiRef}
        ></div>
    );
}